import React, { useState, useEffect } from "react";
import logo from "../../Images/Avatar.png"; // fallback/default image
import OfferPage from "./offerpage";
import LinkCard from "./linkcard";
import { BASEAPIURL, token } from "../../env";
import Bookingstatus from "./Bookingstatus";

const ProfileComponent = () => {
  const [memberData, setMemberData] = useState(null);
  const [relationData, setRelationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showProfile, setShowProfile] = useState(false); // toggle

  useEffect(() => {
    const memberID = sessionStorage.getItem("MemberID");

    if (!memberID) {
      setError("No MemberID found in sessionStorage.");
      setLoading(false);
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    // Fetch Member Data
    fetch(`${BASEAPIURL}/MemberByID?MainID=${memberID}`, {
      ...requestOptions,
      body: JSON.stringify({ tokenData: token }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Error fetching member data: ${res.status}`);
        return res.json();
      })
      .then((result) => {
        setMemberData(result?.data || null);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to fetch member data.");
        setLoading(false);
      });

    // Fetch Relation Data
    fetch(`${BASEAPIURL}/DependentListByMemID?MemID=${memberID}`, {
      ...requestOptions,
      body: JSON.stringify({ tokenData: token }),
    })
      .then((res) => res.json())
      .then((result) => {
        setRelationData(result?.data || []);
      })
      .catch(() => setRelationData([]));
  }, []);

  const memberImage = memberData?.ImageBase64
    ? memberData.ImageBase64.startsWith("data:")
      ? memberData.ImageBase64
      : `data:image/jpeg;base64,${memberData.ImageBase64}`
    : logo;

  return (
    <div className="container-fluid p-2">
      {/* Profile Button */}
      <div className="d-flex justify-content-end p-0">
        <button
          className="btn  d-flex align-items-center p-0"
          onClick={() => setShowProfile(!showProfile)}
        >
          <img
            src={memberImage}
            alt="profile"
            className="rounded-circle "
            style={{ width: "35px", height: "35px", objectFit: "cover" }}
          />
          Profile
        </button>
      </div>

      {/* Show Profile Data Inline when button is clicked */}
      {showProfile && (
        <section className="p-3 border rounded mb-4 bg-light">
          {loading && <div className="text-center">Loading profile...</div>}
          {error && <div className="text-danger">Error: {error}</div>}
          {!loading && !error && memberData && (
            <div className="row">
              {/* Column 1: Basic Info */}
              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label className="form-label">Mobile No.</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={memberData.MemMobileNo || ""}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    value={memberData.MemDOB || ""}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Date of Marriage</label>
                  <input
                    type="date"
                    className="form-control"
                    value={memberData.MemDOM || ""}
                    readOnly
                  />
                </div>
              </div>

              {/* Column 2: Occupation */}
              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label className="form-label">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    value={memberData.Occupations?.[0]?.CompName || ""}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Nature of Business</label>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    value={memberData.Occupations?.[0]?.NatureOfBusiness || ""}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <textarea
                    rows={5}
                    className="form-control"
                    value={memberData.MemAddress || ""}
                    readOnly
                  />
                </div>
              </div>

              {/* Column 3: Relations */}
              <div className="col-12 col-md-4">
                <h5 className="fw-bold">Relations</h5>
                {relationData.length > 0 ? (
                  relationData.map((rel, idx) => (
                    <div key={idx} className="d-flex align-items-center mb-2">
                      <img
                        alt={rel.Name}
                        src={rel.Dep_ImageName || logo}
                        className="rounded-circle me-2"
                        style={{ width: "45px", height: "45px", objectFit: "cover" }}
                      />
                      <div>
                        <div className="fw-semibold">{rel.Name}</div>
                        <div className="text-muted small">{rel.Relation}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No Relations Found</p>
                )}
              </div>
            </div>
          )}
        </section>
      )}

      {/* Other sections */}
      {/* <section className="mt-1">
        <Bookingstatus />
      </section> */}


      <section className="mt-1">
        <LinkCard showBackButton={true} />
      </section>

      <section className="justify-content-end mt-2 ">
        <OfferPage />
      </section>
    </div>
  );
};

export default ProfileComponent;
